<template>
  <div id="td">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'td'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/situation/characteristic/Characteristic.vue